import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

type State = {
    externalRedirect: string | null;
    lastLocationPath: string | null;
    lastLocationId: string | null;
    lastCompanyId: string | null;
};

type Action = {
    setExternalRedirect: (redirect: string | null) => void;
    setLastLocationPath: (path: string | null) => void;
    setLastLocationId: (id: string | null) => void;
    setLastCompanyId: (id: string | null) => void;
};

const initialState: State = {
    externalRedirect: null,
    lastLocationPath: null,
    lastLocationId: null,
    lastCompanyId: null,
};

export const useRedirectStore = create(
    persist(
        devtools<State & Action>((set) => ({
            ...initialState,
            setExternalRedirect: (redirect: string | null) =>
                set({ externalRedirect: redirect }),
            setLastLocationPath: (path: string | null) =>
                set({ lastLocationPath: path }),
            setLastLocationId: (id: string | null) =>
                set({ lastLocationId: id }),
            setLastCompanyId: (id: string | null) => set({ lastCompanyId: id }),
        })),
        { name: "redirect-storage" }
    )
);
